import React from "react";
import { Button } from "@gcs/design-system/react";

import { ButtonLinkStyled } from "../../../../components/common/Buttons/Button.Style";
import { ReactComponent as CallIcon } from "../../../../assets/images/icons/zeppelin-call-icon.svg";
import { ReactComponent as SacIcon } from "../../../../assets/images/icons/sac-icon.svg";

import * as S from "./SacSection.style";

export const SacSection = () => {
  const handleClickRedirect = (url) => {
    const allowedUrls = ["https://wa.me/5508002742000", "tel:08002742000"];

    if (!url || !allowedUrls.includes(url)) return;

    window.open(url);
  };

  return (
    <S.SacSectionContainer>
      <S.SacSectionContent className="container">
        <S.SacSectionBlock>
          <S.SacSectionBlockHeader>
            <S.SacSectionBlockTitle>SAC 24h</S.SacSectionBlockTitle>

            <S.SacSectionBlockDescription>
              Informações, dúvidas, sugestões, reclamações e cancelamentos.
              <br /> Das 21h às 8h, converse com a gente apenas pelo WhatsApp no
              mesmo número.
            </S.SacSectionBlockDescription>
          </S.SacSectionBlockHeader>

          <S.SacSectionBlockFooter>
            <Button
              type="button"
              variant="outlined"
              onClick={() => handleClickRedirect("https://wa.me/5508002742000")}
            >
              Abrir WhatsApp
            </Button>

            <ButtonLinkStyled
              type="button"
              onClick={() => handleClickRedirect("tel:08002742000")}
            >
              <CallIcon />
              0800 274 2000
            </ButtonLinkStyled>
          </S.SacSectionBlockFooter>
        </S.SacSectionBlock>

        <SacIcon width={197} height={197} />
      </S.SacSectionContent>
    </S.SacSectionContainer>
  );
};
